import React from "react";
import "./styles.scss";

import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";

const Question = ({
  length,
  questionNumber,
  question,
  qtnValue,
  setQtnValue,
}) => {
  const Navigate = useNavigate();
  const handleChange = (value, id) => {
    const localValue = JSON.parse(sessionStorage.getItem("qtnValues"));

    JSON.stringify(
      sessionStorage.setItem(
        "qtnValues",
        JSON.stringify({
          ...localValue,
          question: {
            ...localValue?.question,
            [questionNumber]: {
              id: id,
              value: value,
            },
          },
        })
      )
    );
    setQtnValue((prev) => ({
      ...prev,
      [questionNumber]: value,
    }));
    if (length > parseInt(questionNumber)) {
      setTimeout(() => {
        Navigate(
          `${process.env.REACT_APP_BASE}/assessment/question_${
            parseInt(questionNumber) + 1
          }`
        );
      }, [800]);
    } else {
      Navigate(`${process.env.REACT_APP_BASE}/assessment-result`);
    }
  };

  return (
    <div className="question-container">
      <p>
        {questionNumber}. {question?.[0]?.question}
      </p>
      <div className="btn">
        <Button
          className={`${qtnValue === question?.[0]?.answer_1 ? "Active" : ""}`}
          onClick={() =>
            handleChange(question?.[0]?.answer_1, question?.[0]?.question_no)
          }
        >
          Yes
        </Button>
        <Button
          className={`${qtnValue === question?.[0]?.answer_2 ? "Active" : ""}`}
          onClick={() =>
            handleChange(question?.[0]?.answer_2, question?.[0]?.question_no)
          }
        >
          No
        </Button>
      </div>
    </div>
  );
};

export default Question;
